
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.25 10.25A.75.75 0 019 11v6.19l1.22-1.22a.75.75 0 111.06 1.06l-2.5 2.5a.75.75 0 01-1.06 0l-2.5-2.5a.75.75 0 111.06-1.06l1.22 1.22V11a.75.75 0 01.75-.75zM15.22 4.47a.75.75 0 011.06 0l2.5 2.5a.75.75 0 01-1.06 1.06L16.5 6.81V13a.75.75 0 01-1.5 0V6.81l-1.22 1.22a.75.75 0 11-1.06-1.06l2.5-2.5z"}})])
          )
        }
      }
    